module.exports = __webpack_public_path__ + "static/media/star.227b61cb.svg";